export default [
    // {
    //   path: "users",
    //   name: "مستخدمي الشركة", // Updated name
    //   component: () => import("@/pages/Company/Users/index"),
    // },
    {
      path: "company-info",
      name: "تفاصيل الشركة", // Updated name
      component: () => import("@/pages/Company/CompanyInfo/index"),
    },
    {
      path: "services",
      name: "خدمات الشركة", // Updated name
      component: () => import("@/pages/Company/Services/index"),
    },
    {
      path: "requests",
      name: "طلبات الشركة", // Updated name
      component: () => import("@/pages/Company/Requests/index"),
    },
];
